<template>
	<div class="animated fadeIn">
		<CommandHeaderV2 :command_service_id="service_id" :record_id="command_id" active="examples">
			<div class="pt-3 pr-3 pb-0 pl-3">
				<button @click="newExample()" class="pull-right mt-0 btn btn-dark btn-md d-block">
					<i class="fa fa-plus mr-1"></i>
					{{ $t('New Example') }}
				</button>
				<!-- TODO: ask if this condition should be removed -->
				<button
					v-if="command_data.command_lang != 'ar' || user.engine_type == 'bert'" @click="trainAll()"
					:class="[trainingDisabled ? 'btn-danger' : 'btn-success' , 'pull-right mt-0 btn btn-md d-block']"
					:disabled="trainingDisabled"
				>
					<i :class="trainBtnIcon"></i>
					{{ trainBtnLabel }}
				</button>

				<b-card v-for="(record, _ind) in records" :key="`example-${_ind}`" class="mb-3 clearfix">
					<tooltip label="example" placement="right">
						<input
							:name="'record_' + _ind"
							v-model="record.example_text"
							v-validate="'required'"
							:class="{'form-control': true, 'is-invalid': errors.has('record_' + _ind)}"
							:placeholder="$t('Type Example')"
						/>
						<span
							v-show="errors.has('record_' + _ind)"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first('record_' + _ind)) }}</span>
					</tooltip>
					<p v-if="vars.length">
						<button @click="tag(record)" class="btn btn-sm btn-primary">{{ $t('Tag') }}</button>
					</p>
					<table
						v-show="record.example_vars.length > 0"
						class="table table-bordered table-striped table-sm"
					>
						<thead>
							<tr>
								<td>{{ $t('Tag') }}</td>
								<td>{{ $t('Variable') }}</td>
								<td>{{ $t('action') }}</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(ex_var, i) in record.example_vars" :key="`example_vars-${i}`">
								<td>{{ ex_var.tag }}</td>
								<td>
									<select class="form-control" v-model="ex_var.type">
										<option v-for="(v, ii) in vars" :value="v.var_id" :key="`vars-${ii}`">{{ v.var_name }}</option>
									</select>
								</td>
								<td>
									<i @click="remove_tag(record, _ind)" class="fa fa-remove fa-lg"></i>
								</td>
							</tr>
						</tbody>
					</table>
					<div>
						<button @click="saveExample(_ind)" class="btn btn-sm btn-primary">
							<font-awesome-icon icon="save" />
							{{ $t('save') }}
						</button>
						<button @click="deleteExample(_ind)" class="btn btn-sm btn-danger">
							<font-awesome-icon icon="trash" />
							{{ $t('Remove') }}
						</button>
						<button @click="toggleAugmentModal(_ind)" class="btn btn-sm btn-success">
							<font-awesome-icon icon="puzzle-piece" />
							{{ $t('augment') }}
						</button>
					</div>
				</b-card>
			</div>
		</CommandHeaderV2>
		<b-modal
			title="Augments"
			class="modal-primary"
			size="xl"
			hide-footer
			v-model="augmentSuggestions">
			<div class="row ">
				<div class="col">
					<tooltip label="value" placement="right">
						<input
							name="augment_value"
							v-model="augment.value"
							v-validate="'required'"
							:class="{'form-control': true, 'is-invalid': errors.has('augment_value')}"
							:placeholder="$t('value')"
						/>
						<span
							v-show="errors.has('augment_value')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first('value')) }}</span>
					</tooltip>
				</div>
				<div class="col">
					<tooltip label="max_samples" placement="right">
						<input
							name="augment_max_samples"
							v-model="augment.max_samples"
							v-validate="'required'"
							:class="{'form-control': true, 'is-invalid': errors.has('augment_max_samples')}"
							:placeholder="$t('max_samples')"
						/>
						<span
							v-show="errors.has('augment_max_samples')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first('max_samples')) }}</span>
					</tooltip>
				</div>
				<div class="col">
					<tooltip label="level" placement="right">
						<input
							name="augment_lev_min_ratio"
							v-model="augment.lev_min_ratio"
							v-validate="'required'"
							:class="{'form-control': true, 'is-invalid': errors.has('augment_lev_min_ratio')}"
							:placeholder="$t('level')"
						/>
						<span
							v-show="errors.has('augment_lev_min_ratio')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first('level')) }}</span>
					</tooltip>
				</div>
			</div>


			<!-- <button @click="augmentExamples()" class="btn btn-sm btn-success">
				<font-awesome-icon icon="puzzle-piece" />
				{{ $t('augment') }}
			</button> -->
			<div class="popup-loader" v-show="popup_loader">
				<div
					class="blockUI blockOverlay"
					style="z-index: 1000;border: none;margin: 0px;padding: 0px;width: 100%;height: 100%;top: 0px;left: 0px;bottom: 0;background-color: #eee;opacity: 0.4;cursor: wait;position: fixed;"
				></div>
				<div
					class="blockUI blockMsg blockElement"
					style="z-index: 1060;position: fixed;padding: 0px;margin: auto;width: 80px;top: 0;left: 0;text-align: center;color: rgb(0, 0, 0);border: 0px;cursor: wait;bottom: 0;right: 0;height: 20px;"
				>
					<div class="loading-message">
						<div class="block-spinner-bar">
							<div class="bounce1"></div>
							<div class="bounce2"></div>
							<div class="bounce3"></div>
						</div>
					</div>
				</div>
			</div>
			<table v-if="augmentSuggestionResult.length > 0" class="table table-bordered table-striped aug-table">
				<thead>
					<tr>
						<th class="cp">
							<input
								v-model="allSuggestionsChecked"
								type="checkbox"
								v-validate="'required'"
							/>
						</th>
						<th>
							{{ $t('value') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(val, index) in augmentSuggestionResult" :key="`vars-${index}`">
						<td class="cp">
							<input
								:name="'augment_checked_' + index"
								v-model="augmentSuggestionResult[index].checked"
								type="checkbox"
								v-validate="'required'"
							/>
						</td>
						<td class="example-text">
							<input
								:name="'augment_val_' + index"
								v-model="augmentSuggestionResult[index].value"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('augment_val_' + index)}"
								:placeholder="$t('value')"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<b-button variant="btn btn-sm btn-danger" @click="toggleAugmentModal()">
				{{ $t('close') }}
			</b-button>
			<b-button variant="btn btn-sm btn-success" @click="addSuggestions(false)">
				{{ $t('add') }}
			</b-button>
			<b-button variant="btn btn-sm btn-primary" @click="addSuggestions(true)">
				{{ $t('add_and_close') }}
			</b-button>
			<b-button variant="btn btn-sm btn-dark" @click="augmentExamples()">
				{{ $t('refresh') }}
			</b-button>
		</b-modal>
	</div>
</template>
<script>
	import axios from 'axios'

	import CommandHeaderV2 from '../../../components/CommandHeaderV2'

	/**
	 * @vuese
	 *
	 * @group CommandResponse
	 *
	 */
	export default {
		name: 'CommandExamples',
		components: {
			// cSwitch,
			CommandHeaderV2,
		},
		data() {
			return {
				popup_loader: false,
				text_selection: '',
				records: [],
				vars: [],
				service_id: 0,
				command_id: 0,
				deleteModal: false,
				active_element_id: 0,
				active_element_name: '',
				trainBtnIcon: 'fa fa-tachometer mr-1',
				trainBtnLabel: 'Train',
				trainingDisabled: true,
				command_data: {},
				augmentSuggestions: false,
				augment: {},
				augmentSuggestionResult: [],
				allSuggestionsChecked: true
			}
		},
		methods: {
			/**
			 * @vuese
			 *
			 * Add new example
			 */
			newExample() {
				this.records = [
					{
						example_command_id: this.command_id,
						example_text: '',
						example_vars: [],
						example_status: 1,
					},
				].concat(this.records)
			},

			/**
			 * @vuese
			 *
			 * Save example
			 *
			 * @arg   {Integer}  i  index
			 *
			 */
			saveExample(i) {
				let example = this.records[i],
					field = 'record_' + i

				if (example) {
					this.$validator.validateAll([field]).then((success) => {
						if (success) {
							this.$root.loader = true

							axios
								.post('/command_example/save_example', {
									...example,
								})
								.then(({data}) => {
									this.$root.loader = false
									if (data.status == 1) {
										this.records[i] = data.data
									}
								})
								.catch((e) => {
									console.warn(e)
									this.$root.loader = false
								})
						}
					})
				}
				return
			},

			/**
			 * @vuese
			 *
			 * Delete example
			 *
			 * @arg   {Integer}  i  Index
			 *
			 */
			deleteExample(i) {
				let example = this.records.splice(i, 1)
				if (example.length) {
					example = example[0]
					if (example.hasOwnProperty('_id')) {
						axios.delete('/command_example/delete/' + example._id)
					}
				}
			},

			/**
			 * View the augment modal
			 *
			 * @arg {Integer} i Index
			 */
			toggleAugmentModal(i) {
				if (i != undefined) {
					this.augmentSuggestionResult = [];
					let example = this.records[i]
					this.augment.value = example.example_text;
					this.augment.max_samples = 5;
					this.augment.lev_min_ratio = 35;

					this.augmentExamples()
				}

				this.augmentSuggestions = !this.augmentSuggestions;
			},

			/**
			 * Get augment suggestion for the example
			 */
			augmentExamples() {
				this.popup_loader = true

				this.augmentSuggestionResult = [];
				var myHeaders = new Headers()
				myHeaders.append('Content-Type', 'application/json')

				axios
					.post('/command_example/augment_example', {
						example: this.augment.value,
						max_samples: this.augment.max_samples,
						lev_min_ratio: this.augment.lev_min_ratio
					})
					.then((response) => {
						response.data.augmented_texts.forEach(element => {
							this.augmentSuggestionResult.push({
								value: element,
								checked: true
							})
						});

						this.popup_loader = false
					})
			},

			/**
			 * Add a suggestion to the records
			 *
			 * @arg {Integer} i Index
			 */
			addSuggestions(close) {
				this.augmentSuggestionResult.forEach(suggestion => {
					if (suggestion.checked) {
						this.records = [
							{
								example_command_id: this.command_id,
								example_text: suggestion.value,
								example_vars: [],
								example_status: 1,
							},
						].concat(this.records)
					}
				})

				if (close) {
					this.toggleAugmentModal()
				} else {
					this.augmentExamples();
				}
			},

			/**
			 * @vuese
			 *
			 * Remove tag from en example
			 *
			 * @arg   {Object}  record
			 * @arg   {Integer}  index
			 *
			 */
			remove_tag(record, index) {
				var all_records = []
				for (var i = 0; i < record.example_vars.length; i++) {
					if (i != index) {
						all_records.push(record.example_vars[i])
					}
				}
				record.example_vars = all_records
			},

			/**
			 * @vuese
			 *
			 * Add tag for example
			 *
			 * @arg   {Object}  record
			 *
			 */
			tag(record) {
				let tag = this.text_selection.trim(),
					tags = record.example_vars.filter((exTag) => exTag.tag != tag)

				if (tag != '' && this.vars.length) {
					tags.push({
						tag: tag,
						type: this.vars[0].var_id,
					})
					record.example_vars = tags
				}
				this.text_selection = ''
			},

			/**
			 * Save examples
			 *
			 * @vuese
			 *
			 */
			save() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.$root.loader = true
						axios
							.post('/command_example/save/' + this.command_id, {
								examples: this.records,
							})
							.then((response) => {
								this.$root.loader = false
							})
					} else {
						// invalid
						this.$root.loader = false
					}
				})
			},

			/**
			 * Extract variables' IDs
			 *
			 * @return  {Array}  List of Ids
			 *
			 * @vuese
			 *
			 */
			getVariablesIDs() {
				return this.vars.reduce(function(prev, current) {
					return prev.concat(current.var_id)
				}, [])
			},

			filterExampleVars(exampleVariables, variablesIDs) {
				return exampleVariables.filter((examVar) => variablesIDs.indexOf(examVar.type) >= 0)
			},

			async getExamples() {
				this.records = []

				const varIds = this.getVariablesIDs()

				const {data} = await axios.post('/command_example/get/' + this.command_id)

				if (data.status == 1) {
					this.records = data.data.reduce((prev, current) => {
						return prev.concat({
							...current,
							example_vars: this.filterExampleVars(current.example_vars, varIds),
						})
					}, [])
				}
				return data
			},

			async getVariablesForCommand(command) {
				const {data} = await axios.post('/command_var/get_all/' + command)

				if (data.status == 1) {
					this.vars = data.data
				}

				return data
			},

			/**
			 *
			 * @vuese
			 *
			 * Set status of en example
			 *
			 * @arg   {Object}  element
			 *
			 */
			set_status(element) {
				var status = 1
				if (element.text == false) {
					status = 1 // reverse the current status
				} else {
					status = 0
				}
				axios
					.post('/command_example/set_status/' + element.id, {
						status: status,
					})
					.then((response) => {
						if (response.data.status == 1) {
							//
						}
					})
			},

			/**
			 * @vuese
			 *
			 * Delete example
			 *
			 * @arg element
			 * @arg alarm
			 */
			delete_it(element, alarm) {
				if (alarm) {
					this.deleteModal = true
					this.active_element_id = element.id
					this.active_element_name = element.text
				} else {
					if (this.active_element_id > 0) {
						this.$root.loader = true
						axios.post('/command_example/delete/' + this.active_element_id, {}).then((response) => {
							if (response.data.status == 1) {
								this.deleteModal = false
								this.getExamples()
							}
						})
					}
				}
			},

			handleOnTag() {
				document.onmouseup = document.onkeyup = document.onselectionchange = () => {
					var text = getSelectionText()
					if (text) {
						this.text_selection = text
					}
				}
			},

			trainExample() {
				this.training();
				axios
					.get(`/command_example/train/${this.command_id}`)
					.then((response) => {
						if (response.data.status == 1) {
							console.log(response.data);
						}

						this.endTraining();
					})
					.catch(err => {
						console.log(err);

						this.endTraining();
					})
			},

			trainAll() {
				this.training();
				axios
					.get('/command_example/train')
					.then((response) => {
						if (response.data.status == 1) {
							this.$toastr.s(response.data.msg);
							this.trainingDisabled = true;
						} else {
							this.$toastr.e(response.data.msg);
						}

						this.endTraining();
					})
					.catch(err => {
						this.$toastr.e('Something went wrong');
						console.error(err);
						this.endTraining();
					})
			},

			training() {
				this.trainBtnIcon = 'fa fa-spinner fa-spin mr-1'
				this.trainBtnLabel = 'Training'
			},

			endTraining() {
				this.trainBtnIcon = 'fa fa-tachometer mr-1'
				this.trainBtnLabel = 'Train'
			},

			async getCommandData() {
				axios.get(`/command/browse/${this.command_id}`).then((response) => {
					if (response.data.status) {
						this.command_data = response.data.data;
					}
				})
			},

			checkIfFree() {
				axios.get('/command_example/check-if-free').then((response) => {
					if (response.data.status != undefined) {
						if(response.data.msg == "still running"){
							this.trainBtnIcon = 'fa fa-spinner fa-spin mr-1';
						} else {
							this.trainBtnIcon = 'fa fa-tachometer mr-1';
						}
						this.trainingDisabled = !response.data.status
					} else {
						this.trainingDisabled = true
					}
				})
			}
		},

		/**
		 * @vuese
		 *
		 * Mounted
		 */
		async mounted() {
			if (parseInt(this.$route.params.service_id) >= 1) {
				this.service_id = parseInt(this.$route.params.service_id)
			}
			if (parseInt(this.$route.params.command_id) >= 1) {
				this.command_id = parseInt(this.$route.params.command_id)
			}

			await this.getVariablesForCommand(this.command_id)
			await this.getExamples()
			await this.getCommandData();

			this.handleOnTag()
			this.checkIfFree()
			setInterval(this.checkIfFree, 10000);
		},

		watch: {
			allSuggestionsChecked: function(checked) {
				for (let i = 0; i < this.augmentSuggestionResult.length; i++) {
					this.augmentSuggestionResult[i].checked = checked;
				}
			}
		},

		computed: {
			user() {
				return this.$store.state.user;
			}
		}
	}
</script>
<style scoped>
	.aug-table .cp{
		max-width: 50px !important;
	}

	.aug-table .example-text input{
		text-align: center;
	}
</style>
